// Simple i18n dictionary. Every user-facing string used across the app.
export const dict = {
  en: {
    app_name: "HAG Carpets Ops",
    tagline: "Loom-to-ledger, from Mirzapur.",
    login: "Sign In",
    username: "Username",
    password: "Password",
    logout: "Sign Out",
    language: "भाषा / Language",
    hindi: "हिन्दी",
    english: "English",
    role_inspector: "Field Inspector",
    role_supervisor: "Daura Supervisor",
    role_coordinator: "Data Coordinator",
    role_merchandiser: "Merchandiser",
    role_director: "Director",
    // Navigation
    nav_todays_route: "Today's Route",
    nav_my_escalations: "My Escalations",
    nav_my_scorecard: "My Scorecard",
    nav_assignment_queue: "Assignment Queue",
    nav_live_board: "Live Board",
    nav_escalations_inbox: "Escalations Inbox",
    nav_route_planner: "Route Planner",
    nav_grade_review: "Grade Review",
    nav_missing_etas: "Fix Missing ETAs",
    nav_unallocated: "Vendor Not Yet Allocated",
    nav_master_data: "Master Data",
    nav_weekly_mis: "Weekly MIS",
    nav_po_register: "PO Register",
    nav_new_po: "New PO",
    nav_my_pos: "My POs",
    nav_dashboard: "Dashboard",
    nav_audit_mode: "Audit Mode",
    nav_audit_mismatches: "Audit Mismatches",
    nav_import: "Data Import",
    nav_import_health: "Import Health",
    nav_csv_upload: "CSV Upload",
    nav_maintenance: "Maintenance",
    nav_kra_leaderboard: "KRA Leaderboard",
    nav_refresh: "Refresh Checklist",
    nav_device_sync: "Device Sync",
    nav_help: "Help / सहायता",
    nav_factory_wip: "Factory WIP",
    nav_finishing: "Finishing",
    nav_grn: "Goods Receipt",
    nav_stock_on_hand: "Stock on Hand",
    nav_despatch: "Despatch",
    nav_vendor_followup: "Vendor Follow-up",
    nav_portal_tokens: "Vendor Portal Links",
    nav_mg_dashboard: "MG Workspace",
    nav_mg_inspections: "Loom Inspections",
    nav_mg_yarn: "Yarn Ledger",
    role_prod_qc_coordinator: "Prod & QC Coordinator",
    role_qc_officer: "QC Officer",
    role_wash_master: "Wash Master",
    role_finisher: "Finisher",
    role_stores_coordinator: "Stores Coordinator",
    role_vendor_mg: "MG Rugs Workspace",
    role_ric_staff: "RIC Godown Staff",
    role_ric_supervisor: "RIC Supervisor",
    role_security_guard: "Security Guard",
    nav_ric_trade: "MG ↔ RIC Trade Log",
    nav_mg_yarn_po: "Yarn POs on RIC",
    nav_mg_pieces: "Piece Register",
    nav_ric_dashboard: "RIC Home",
    nav_ric_receive: "Receive yarn",
    nav_ric_transfer: "Bin transfer",
    nav_ric_po_queue: "MG PO queue",
    nav_ric_sale: "Weaver sale",
    nav_ric_count: "Physical count",
    nav_ric_stock: "Stock browser",
    nav_ric_disc: "Discrepancies",
    // Phase 5
    nav_guard_today: "Today’s Passes",
    nav_gate_register: "Gate Pass Register",
    nav_jw_register: "Job Work Challans",
    nav_jw_workers: "Job Workers",
    nav_hr_staff: "Staff Master",
    nav_hr_attendance: "Daily Attendance",
    nav_hr_month: "Month Register",
    nav_hr_leaves: "Leaves",
    nav_visitors: "Visitors",
    // Common
    save: "Save",
    cancel: "Cancel",
    submit: "Submit",
    edit: "Edit",
    assign: "Assign",
    close: "Close",
    yes: "Yes",
    no: "No",
    loading: "Loading…",
    // Inspection
    inspection_form: "Inspection",
    milestone: "Milestone",
    percent_complete: "% Complete",
    length_woven: "Length woven (cm)",
    kpsi: "Knot density (KPSI)",
    width_inches: "Width (inches)",
    pile_heights: "Pile heights at 3 points (mm)",
    checklist: "Checklist",
    photos: "Photos",
    defects: "Defects",
    grade: "Grade",
    grade_note: "Note (if overriding suggestion)",
    start_inspection: "Start Inspection",
    add_photo: "Add Photo",
    capturing_gps: "Capturing GPS…",
    gps_required: "Location required. Please enable GPS.",
    pending_sync: "Pending sync",
    synced: "Synced",
    weaver: "Weaver",
    loom_no: "Loom",
    zone: "Zone",
    last_visit: "Last visit",
    last_grade: "Last grade",
    eta: "ETA",
    po_number: "PO Number",
    weaver_name: "Weaver",
    design: "Design",
    size: "Size",
    validation_eta_required: "ETA is mandatory — please provide a due date.",
    validation_photo_required: "At least one photo is required.",
    validation_milestone_skip: "Cannot skip milestones. Record the previous milestone first.",
    class_critical: "Critical",
    class_major: "Major",
    class_minor: "Minor",
    add_defect: "Add defect",
    domain_quality: "A. Quality",
    domain_measurement: "B. Measurement",
    domain_progress: "C. Progress",
    domain_loom_weaver: "D. Loom & Weaver",
    domain_risk: "E. Risk flags",
    pass: "Pass",
    fail: "Fail",
    na: "N/A",
    note: "Note",
    inspector: "Inspector",
    assigned_inspector: "Assigned inspector",
    active_looms: "Active looms",
    delayed: "Delayed",
    on_time: "On time",
    open_escalations: "Open escalations",
    critical: "Critical",
    top_delayed: "Top delayed POs",
    lsd_outstanding: "LSD outstanding pcs",
    lsd_overdue: "Overdue lines",
    lsd_due_soon: "Due ≤ 14 days",
    unallocated_vendor: "Unallocated vendor",
    login_error: "Invalid username or password.",
    welcome: "Welcome back",
    total_looms: "Total looms",
    stopped_looms: "Stopped looms",
    pending_inspector_assignment: "Pending inspector assignment",
    fix_missing_etas: "Fix Missing ETAs",
    reason: "Reason",
    revise_grade: "Revise grade",
    resolve: "Resolve",
    rework_instruction: "Rework instruction",
    escalations: "Escalations",
    submitted: "Submitted",
    days_behind: "days behind",
    overdue: "OVERDUE",
    vendors: "Vendors",
    weavers: "Weavers",
    looms: "Looms",
    designs: "Designs",
    export_pdf: "Export PDF",
    export_excel: "Export Excel",
    scorecard: "Scorecard",
    milestone_completion: "Milestone completion %",
    inspections_done: "Inspections done",
    defects_caught: "Defects caught",
    a_grades: "A-grade closures",
    inspector_league: "Inspector league",
    behind_schedule: "Behind schedule",
    // Statuses
    "st.Draft - ETA Missing": "Draft — ETA Missing",
    "st.Pending Inspector Assignment": "Pending Inspector Assignment",
    "st.Issued": "Issued",
    "st.Raw Material Issued": "Raw Material Issued",
    "st.In Progress (Daura)": "In Progress (Daura)",
    "st.Final QC": "Final QC",
    "st.Received": "Received",
    "st.Reconciliation": "Reconciliation",
    "st.Closed": "Closed",
    "st.Cancelled": "Cancelled",
    // Field-facing extras
    export_csv: "Export CSV",
    filter: "Filter",
    all: "All",
    search: "Search",
    no_items: "No items to show.",
    no_escalations: "No escalations raised.",
    no_inspections_yet: "No inspections yet.",
    no_looms_route: "No looms on today's route yet. Ask your supervisor to plan your route.",
    inspection_history: "Inspection history",
    view_weaver_profile: "View weaver profile",
    loom_stopped_msg: "Loom is Stopped — awaiting supervisor resolution of critical escalation.",
    validation_desc_required: "Please add a description.",
    validation_rework_required: "Rework instruction is required to resolve.",
    validation_reason_required: "A reason is required.",
    critical_defect_warning: "Critical defect will Stop the loom and raise a supervisor escalation.",
    row_number: "Row #",
    description: "Description",
    milestone_locked: "This record is locked after submission.",
    photo_captured: "Photo captured",
    uploading: "Uploading…",
    saved: "Saved",
    share_whatsapp: "Share to WhatsApp",
    sync_now: "Sync now",
    offline: "Offline",
    online: "Online",
    critical_defect_confirm: "Adding a Critical defect will STOP this loom and notify the supervisor. Continue?",
    // Status labels (chips)
    "st.Open": "Open",
    "st.Resolved": "Resolved",
    "st.In Progress": "In Progress",
    "st.Active": "Active",
    "st.Idle": "Idle",
    "st.Stopped": "Stopped",
    "st.Pending": "Pending",
    "st.On Loom": "On Loom",
    "st.Woven": "Woven",
    "st.Returned": "Returned",
  },
  hi: {
    app_name: "HAG कारपेट्स",
    tagline: "मिर्ज़ापुर से — करघे से किताब तक।",
    login: "साइन इन",
    username: "यूज़रनेम",
    password: "पासवर्ड",
    logout: "साइन आउट",
    language: "भाषा / Language",
    hindi: "हिन्दी",
    english: "English",
    role_inspector: "फ़ील्ड इंस्पेक्टर",
    role_supervisor: "दौरा सुपरवाइज़र",
    role_coordinator: "डेटा कोऑर्डिनेटर",
    role_merchandiser: "मर्चेंडाइज़र",
    role_director: "डायरेक्टर",
    nav_todays_route: "आज का रूट",
    nav_my_escalations: "मेरी शिकायतें",
    nav_my_scorecard: "मेरा स्कोरकार्ड",
    nav_assignment_queue: "असाइनमेंट क्यू",
    nav_live_board: "लाइव बोर्ड",
    nav_escalations_inbox: "शिकायत बॉक्स",
    nav_route_planner: "रूट प्लानर",
    nav_grade_review: "ग्रेड समीक्षा",
    nav_missing_etas: "ETA सही करें",
    nav_unallocated: "वेंडर आवंटित नहीं",
    nav_master_data: "मास्टर डेटा",
    nav_weekly_mis: "साप्ताहिक MIS",
    nav_po_register: "PO रजिस्टर",
    nav_new_po: "नया PO",
    nav_my_pos: "मेरे PO",
    nav_dashboard: "डैशबोर्ड",
    nav_audit_mode: "ऑडिट मोड",
    nav_audit_mismatches: "ऑडिट मिसमैच",
    nav_import: "डेटा इम्पोर्ट",
    nav_import_health: "इम्पोर्ट हेल्थ",
    nav_csv_upload: "CSV अपलोड",
    nav_maintenance: "रखरखाव",
    nav_kra_leaderboard: "KRA लीडरबोर्ड",
    nav_refresh: "रिफ्रेश चेकलिस्ट",
    nav_device_sync: "डिवाइस सिंक",
    nav_help: "सहायता / Help",
    nav_factory_wip: "फैक्ट्री WIP",
    nav_finishing: "फिनिशिंग",
    nav_grn: "माल प्राप्ति",
    nav_stock_on_hand: "उपलब्ध स्टॉक",
    nav_despatch: "प्रेषण",
    nav_vendor_followup: "वेंडर फॉलो-अप",
    nav_portal_tokens: "वेंडर पोर्टल लिंक",
    nav_mg_dashboard: "MG वर्कस्पेस",
    nav_mg_inspections: "लूम निरीक्षण",
    nav_mg_yarn: "यार्न लेजर",
    role_prod_qc_coordinator: "प्रोड व QC कोऑर्डिनेटर",
    role_qc_officer: "QC ऑफिसर",
    role_wash_master: "वॉश मास्टर",
    role_finisher: "फिनिशर",
    role_stores_coordinator: "स्टोर कोऑर्डिनेटर",
    role_vendor_mg: "MG रग्स वर्कस्पेस",
    role_ric_staff: "RIC गोदाम स्टाफ़",
    role_ric_supervisor: "RIC सुपरवाइज़र",
    role_security_guard: "सिक्योरिटी गार्ड",
    nav_ric_trade: "MG ↔ RIC ट्रेड लॉग",
    nav_mg_yarn_po: "RIC पर यार्न PO",
    nav_mg_pieces: "पीस रजिस्टर",
    nav_ric_dashboard: "RIC होम",
    nav_ric_receive: "यार्न प्राप्त",
    nav_ric_transfer: "बिन ट्रांसफर",
    nav_ric_po_queue: "MG PO लाइन",
    nav_ric_sale: "बुनकर बिक्री",
    nav_ric_count: "फिज़िकल गिनती",
    nav_ric_stock: "स्टॉक ब्राउज़र",
    nav_ric_disc: "विसंगतियाँ",
    // Phase 5
    nav_guard_today: "आज के पास",
    nav_gate_register: "गेट पास रजिस्टर",
    nav_jw_register: "जॉब वर्क चालान",
    nav_jw_workers: "जॉब वर्कर",
    nav_hr_staff: "स्टाफ़ मास्टर",
    nav_hr_attendance: "दैनिक हाज़िरी",
    nav_hr_month: "मासिक रजिस्टर",
    nav_hr_leaves: "छुट्टियाँ",
    nav_visitors: "विज़िटर",
    save: "सहेजें",
    cancel: "रद्द",
    submit: "जमा करें",
    edit: "बदलें",
    assign: "असाइन",
    close: "बंद",
    yes: "हाँ",
    no: "नहीं",
    loading: "लोड हो रहा है…",
    inspection_form: "निरीक्षण",
    milestone: "माइलस्टोन",
    percent_complete: "% पूरा",
    length_woven: "बुनाई लंबाई (cm)",
    kpsi: "गाँठ घनत्व (KPSI)",
    width_inches: "चौड़ाई (इंच)",
    pile_heights: "पाइल ऊँचाई 3 जगह (mm)",
    checklist: "चेकलिस्ट",
    photos: "फोटो",
    defects: "दोष",
    grade: "ग्रेड",
    grade_note: "ग्रेड बदलने का कारण",
    start_inspection: "निरीक्षण शुरू करें",
    add_photo: "फोटो लें",
    capturing_gps: "GPS लिया जा रहा है…",
    gps_required: "GPS ज़रूरी है। कृपया लोकेशन ऑन करें।",
    pending_sync: "सिंक बाकी",
    synced: "सिंक हो गया",
    weaver: "बुनकर",
    loom_no: "लूम",
    zone: "ज़ोन",
    last_visit: "पिछला दौरा",
    last_grade: "पिछला ग्रेड",
    eta: "डिलीवरी तारीख़",
    po_number: "PO नंबर",
    weaver_name: "बुनकर",
    design: "डिज़ाइन",
    size: "साइज़",
    validation_eta_required: "डिलीवरी तारीख़ ज़रूरी है।",
    validation_photo_required: "कम से कम एक फोटो ज़रूरी है।",
    validation_milestone_skip: "माइलस्टोन छोड़ नहीं सकते। पहले पिछला माइलस्टोन दर्ज करें।",
    class_critical: "गंभीर",
    class_major: "बड़ा",
    class_minor: "छोटा",
    add_defect: "दोष जोड़ें",
    domain_quality: "A. गुणवत्ता",
    domain_measurement: "B. माप",
    domain_progress: "C. प्रगति",
    domain_loom_weaver: "D. लूम व बुनकर",
    domain_risk: "E. जोखिम",
    pass: "पास",
    fail: "फेल",
    na: "लागू नहीं",
    note: "टिप्पणी",
    inspector: "इंस्पेक्टर",
    assigned_inspector: "असाइन किया इंस्पेक्टर",
    active_looms: "सक्रिय लूम",
    delayed: "देरी से",
    on_time: "समय पर",
    open_escalations: "खुली शिकायतें",
    critical: "गंभीर",
    top_delayed: "टॉप देरी वाले PO",
    lsd_outstanding: "LSD बकाया पीस",
    lsd_overdue: "समय बीत गया",
    lsd_due_soon: "≤14 दिन में",
    unallocated_vendor: "वेंडर नहीं",
    login_error: "यूज़रनेम या पासवर्ड ग़लत है।",
    welcome: "स्वागत है",
    total_looms: "कुल लूम",
    stopped_looms: "रुके हुए लूम",
    pending_inspector_assignment: "इंस्पेक्टर असाइन बाकी",
    fix_missing_etas: "ETA सही करें",
    reason: "कारण",
    revise_grade: "ग्रेड बदलें",
    resolve: "हल",
    rework_instruction: "सुधार निर्देश",
    escalations: "शिकायतें",
    submitted: "जमा हुआ",
    days_behind: "दिन पीछे",
    overdue: "बीत गया",
    vendors: "वेंडर",
    weavers: "बुनकर",
    looms: "लूम",
    designs: "डिज़ाइन",
    export_pdf: "PDF निकालें",
    export_excel: "Excel निकालें",
    scorecard: "स्कोरकार्ड",
    milestone_completion: "माइलस्टोन पूर्ति %",
    inspections_done: "निरीक्षण किए",
    defects_caught: "पकड़े गए दोष",
    a_grades: "A ग्रेड बंद",
    inspector_league: "इंस्पेक्टर लीग",
    behind_schedule: "देरी से",
    "st.Draft - ETA Missing": "ड्राफ्ट — ETA नहीं",
    "st.Pending Inspector Assignment": "इंस्पेक्टर असाइन बाकी",
    "st.Issued": "जारी",
    "st.Raw Material Issued": "कच्चा माल जारी",
    "st.In Progress (Daura)": "प्रगति (दौरा)",
    "st.Final QC": "अंतिम QC",
    "st.Received": "प्राप्त",
    "st.Reconciliation": "मिलान",
    "st.Closed": "बंद",
    "st.Cancelled": "रद्द",
    // Field-facing extras (Hindi)
    export_csv: "CSV निकालें",
    filter: "फ़िल्टर",
    all: "सभी",
    search: "खोजें",
    no_items: "कोई रिकॉर्ड नहीं।",
    no_escalations: "कोई शिकायत दर्ज नहीं।",
    no_inspections_yet: "अभी तक कोई निरीक्षण नहीं।",
    no_looms_route: "आज के रूट पर कोई लूम नहीं। कृपया अपने सुपरवाइज़र से रूट सेट कराएँ।",
    inspection_history: "निरीक्षण इतिहास",
    view_weaver_profile: "बुनकर प्रोफ़ाइल देखें",
    loom_stopped_msg: "लूम रुका हुआ है — सुपरवाइज़र से शिकायत हल होने का इंतज़ार।",
    validation_desc_required: "कृपया विवरण जोड़ें।",
    validation_rework_required: "सुधार निर्देश ज़रूरी है।",
    validation_reason_required: "कारण देना ज़रूरी है।",
    critical_defect_warning: "गंभीर दोष से लूम रुक जाएगा और सुपरवाइज़र को शिकायत जाएगी।",
    row_number: "पंक्ति #",
    description: "विवरण",
    milestone_locked: "जमा करने के बाद रिकॉर्ड लॉक हो जाता है।",
    photo_captured: "फोटो ली गई",
    uploading: "अपलोड हो रहा है…",
    saved: "सहेज लिया",
    share_whatsapp: "WhatsApp पर भेजें",
    sync_now: "अभी सिंक",
    offline: "ऑफलाइन",
    online: "ऑनलाइन",
    critical_defect_confirm: "गंभीर दोष से यह लूम रुक जाएगा और सुपरवाइज़र को सूचना जाएगी। जारी रखें?",
    // Status labels (chips) Hindi
    "st.Open": "खुली",
    "st.Resolved": "हल",
    "st.In Progress": "प्रगति में",
    "st.Active": "सक्रिय",
    "st.Idle": "निष्क्रिय",
    "st.Stopped": "रुका",
    "st.Pending": "बाकी",
    "st.On Loom": "लूम पर",
    "st.Woven": "बुनी हुई",
    "st.Returned": "वापस",
  },
};

export function t(lang, key) {
  return dict[lang]?.[key] ?? dict.en[key] ?? key;
}
